import "@mdi/font/css/materialdesignicons.min.css";

import Vue from "vue";
import "./plugins/axios";
import VueURLPlugin from "./plugins/vueurl";
import filters from "./plugins/filters";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import i18n from "./i18n";
import router from "./router";

import TTButton from "./components/common/TTButton";
import UserBox from "./components/common/UserBox";
import PositiveNumericInput from "./components/common/PositiveNumericInput";
import DateInput from "./components/common/DateInput";
import EditableInput from "./components/common/EditableInput";
import EmailInput from "./components/common/EmailInput";
import TimeInput from "./components/common/TimeInput";

import VuetifyConfirm from "vuetify-confirm";
import VueLogger from "vuejs-logger";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import { VueMaskDirective } from "v-mask";
import moment from "moment";
import VueExcelEditor from "vue-excel-editor";

Vue.use(VuetifyConfirm, {
  vuetify,
});

const vueloggeroptions = {
  isEnabled: true,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};

("#if TARGET === 'development'");
Vue.prototype.$TARGET = "development";
vueloggeroptions["logLevel"] = "debug";
("#else");
Vue.prototype.$TARGET = "production";
vueloggeroptions["logLevel"] = "fatal";
("#endif");

Vue.use(VueLogger, vueloggeroptions);

Vue.use(VuetifyConfirm, {
  buttonTrueColor: "warning",
  buttonFalseColor: "accent",
});

Vue.config.productionTip = false;

Vue.use(VueExcelEditor);
Vue.use(VueURLPlugin);
Vue.use(VuetifyConfirm, {
  vuetify,
});

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

for (let filter of filters) {
  Vue.filter(filter.name, filter.fun);
}

Vue.directive("mask", VueMaskDirective);
Vue.component("tt-button", TTButton);
Vue.component("userbox", UserBox);
Vue.component(PositiveNumericInput.name, PositiveNumericInput);
Vue.component(DateInput.name, DateInput);
Vue.component(EditableInput.name, EditableInput);
Vue.component(EmailInput.name, EmailInput);
Vue.component(TimeInput.name, TimeInput);

// let isLoggedIn = sessionStorage.authToken != null && sessionStorage.authUser != null;
// let user = isLoggedIn ? JSON.parse(sessionStorage.authUser) : null;
// let authToken = sessionStorage.authToken;

// if (isLoggedIn) {
//   Vue.$log.debug('user is already logged in. Commit changed and redirect');
//   store.commit('mLogin', {
//     authtoken: authToken,
//     user: user
//   });
// }

router.beforeEach((to, from, next) => {
  Vue.$log.debug("beforeEach: getLoggedIn: " + store.getters.getLoggedIn);
  Vue.$log.debug("beforeEach: to: ", to);

  if (to.name !== "login" && !store.getters.getLoggedIn) {
    Vue.$log.debug("user not found, looking for openid cookie");
    store
      .dispatch("checkMicrosoftAuth")
      .then(() => {
        if (to.name !== "login" && !store.getters.getLoggedIn) {
          router.push({ name: "login" });
        } else {
          if (to.path.indexOf("/dpr/") == -1) {
            Vue.$log.debug("resetting DPR ctx ...");
            store.commit("mv_dprData/RESET_DPR_CONTEXT");
          }

          next();
        }
      })
      .catch(() => router.push({ name: "login" }));
  } else {
    // store.commit("mShowLongLoader", i18n.t("common.pleasewait"));
    next();
  }
});

/**
 * Formats the given number using thousands separator
 */
Vue.filter("formatTNumber", (value) => {
  const [whole, decimals] = (value || "").toString().split(".");
  return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (decimals ? "." + decimals : "");
});

var hqweb = new Vue({
  vuetify,
  store,
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");

async function loadTranslations() {
  let lang = "en";
  var res = await Vue.axios.get(Vue.$url("i18n/en"));
  Vue.$log.debug("adding translations: ", res.data);
  i18n.setLocaleMessage(lang, res.data);
  i18n.locale = lang;
  Vue.axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  Vue.$log.info("created app: ", hqweb);
  hqweb.$store.commit("mFinishedLoading");
}
loadTranslations();

Vue.mixin({
  methods: {
    dateMixin: function(date) {
      if (date == null) return "";
      /* return i18n.d(new Date(date), "short"); */
      return moment.utc(date).format("DD/MMM/YYYY");
    },
    longDateMixin: function(date) {
      if (date == null) return "";
      return i18n.d(new Date(date), "long");
    },
    longDateMixinFmt: function(date) {
      if (date == null) return "";
      //return i18n.d(new Date(date), "long");
      return moment.utc(date).format("DD/MMM/YYYY HH:mm:ss");
    },
    resolvePath: function(path, obj = self, separator = ".") {
      var properties = Array.isArray(path) ? path : path.split(separator);
      return properties.reduce((prev, curr) => prev && prev[curr], obj);
    },
    isValidEmail: function(email) {
      return email && email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? true : false;
    },
  },
});

export default hqweb;
